<template>
  <div class="customer_details">
    <headBox class="top clearfix">
      <div class="pic">
        <img src="@static/images/yhtx.png" alt="" />
      </div>
      <div class="naph" style="padding-top:10px;">
        <span class="name">{{ PolicyInfo.name }}</span>
        <span class="phone">手机号：{{ PolicyInfo.mobile }}</span>
        <span class="phone"
          >创建时间：{{ PolicyInfo.createTime | timeSubstr(0, 10) }}</span
        >
      </div>
      <div class="ormn" style="padding-top:44px;">
        <span class="order"
          >累计保单：<span
            style="color:#f9990f;display: initial;padding-left:0"
            >{{ PolicyInfo.policyNum }}</span
          >单</span
        >
        <span class="money"
          >累计保费：<span
            style="color:#f9990f;display: initial;padding-left:0"
            >{{ PolicyInfo.totleFee }}</span
          >元</span
        >
      </div>
    </headBox>
    
    <div class="bdta">
      <div class="bdtitle"><i></i><span>客户保单</span></div>
      <el-table
        class="list-table"
        border
        v-loading="listLoading"
        :data="tableData"
        tooltip-effect="dark"
      >
        <emptyBox slot="empty"></emptyBox>
        <el-table-column type="index" label="" :show-overflow-tooltip="true"  min-width="80" fixed="left"></el-table-column>
        <el-table-column
          property="productName"
          label="产品名称"
          min-width="200px;"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          property="policyNo"
          label="保单号"
          min-width="200px;"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column property="createTime" label="创建时间" min-width="170px;" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | timeSubstr(0, 16) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="insuranceName" label="投/被保人姓名" min-width="120px" :show-overflow-tooltip="true">
          <template slot-scope="scope"
            >{{ scope.row.policyerName }}/{{
              scope.row.insuranceName
            }}</template
          >
        </el-table-column>
        <el-table-column property="fee" label="保费（元）" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="startTime" label="起保日期" min-width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime | timeSubstr(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="endTime" label="终保日期" min-width="120px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.endTime | timeSubstr(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ all.POLICY_STATUS[scope.row.policyStatus] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page.sync="pageNum"
        @size-change="pageNum=1;pageSize=$event;getList(1)"
        :layout="$tools.pageLayout"
        @current-change="getList"
        :total="total"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
//当前实例组件
import headBox from "@/components/head2.vue";
import topSearchForm from "@/components/topSearchForm";
export default {
  data: () => ({
    listLoading:true,
    data: "",
    select: "",
    labelPosition: "right",
    tableData: [],
    pageSize:10,
    pageNum:1,
    phone1: "",
    phone2: "",
    totalFee: "",
    totalPolicyNum: "",
    policyerName: "",
    total: 0,
    PolicyInfo: {
      policyNum: 0,
      totleFee: 0
    },
  }),
  components: {
    topSearchForm,
    headBox
  },
  created() {
    this.id = this.$route.query.id;
    this.PolicyInfo.mobile = this.$route.query.mobile;
    this.PolicyInfo.createTime = this.$route.query.time;
    this.PolicyInfo.name = this.$route.query.name;
    this.$forceUpdate();
    this.getState();
    this.querySubMechanPolicyInfo();
  },
  methods: {
    //获取状态
    getState: function() {
      var that = this;
      this.$tools.getall(that.setAll);
    },
    setAll: function(data) {
      this.all = data;
      this.gettableData(1);
    },
    gettableData: function(num) {
      this.listLoading = true;
      this.$http({
        url: "/master/subAccount/querySubMechanPolicy",
        type: "put",
        params: {
          pageNum: num,
          pageSize: this.pageSize,
          mechanId: this.id
        }
      }).then((data)=> {
        this.listLoading = false;
        this.tableData = data.data;
        this.total = data.total;
      });
    },
    querySubMechanPolicyInfo: function() {
      var that = this;
      this.$http({
        url: "/master/subAccount/querySubMechanPolicyInfo",
        type: "get",
        params: {
          mechanId: that.id
        }
      }).then(function(data) {
        if (data.data) {
          that.PolicyInfo = data.data;
        }
      });
    },
    getList: function(val) {
      this.gettableData(val);
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/sass/pages/customer_details";
.customer_details .bdta {
  padding: 30px;
}
.customer_details .bdta .bdtitle {
  margin-bottom: 20px;
}
.customer_details /deep/ .top .fixed-back-btn{
  top: 15px;
}
</style>
